import {
  CustomQuestion,
  CustomQuestionSectionId,
  GuidanceTextStructure,
} from 'admin/pages/ManageAccounts/CustomQuestions/utilts';
import { Indicator, IndicatorGroup } from './ImpactIndicator/utils';

const reachIndicatorIds: {
  [id: string]:
    | {
        [id: string]:
          | {
              ids: number[];
              names: string[];
            }
          | undefined;
      }
    | undefined;
} = {
  'Housing and Human Services': {
    'Basic Needs': {
      ids: [10069, 10068],
      names: ['Meals are distributed', 'Pounds of food are distributed'],
    },
    'Emergency Housing': {
      ids: [10069, 10068],
      names: ['Meals are distributed', 'Pounds of food are distributed'],
    },
  },
  'Food Security': {
    'Community and School-Based Meal Programs': {
      ids: [10069, 10068],
      names: ['Meals are distributed', 'Pounds of food are distributed'],
    },
    'Food Distribution': {
      ids: [10068, 10069],
      names: ['Pounds of food are distributed', 'Meals are distributed'],
    },
    'Growing and Harvesting': {
      ids: [10068, 10069],
      names: ['Pounds of food are distributed', 'Meals are distributed'],
    },
  },
  'Disaster Management': {
    'Disaster Preparation': {
      ids: [10051],
      names: ['Acres of land are protected or restored'],
    },
    'Disaster Response': {
      ids: [10069, 10068],
      names: ['Meals are distributed', 'Pounds of food are distributed'],
    },
  },
  'Environment and Sustainability': {
    'Environmental Conservation': {
      ids: [10023, 10062, 10063, 10064, 10088],
      names: [
        'Acres of land are reached',
        'Miles of riverway are reached',
        'Square miles of oceans are reached',
        'Animals are reached',
        'Trees are planted',
      ],
    },
    'Recycling and Waste': {
      ids: [10023, 10062, 10063],
      names: [
        'Acres of land are reached',
        'Miles of riverway are reached',
        'Square miles of oceans are reached',
      ],
    },
    'Sustainable Agriculture': {
      ids: [10069, 10068],
      names: ['Meals are distributed', 'Pounds of food are distributed'],
    },
    'Wildlife Conservation': {
      ids: [10023, 10064, 10062, 10063, 10088],
      names: [
        'Acres of land are reached',
        'Animals are reached',
        'Miles of riverway are reached',
        'Square miles of oceans are reached',
        'Trees are planted',
      ],
    },
  },
  'Community and Economic Development': {
    'Inclusive Entrepreneurship Systems Change': {
      ids: [10140, 10141],
      names: ['Businesses reached', 'Individuals reached'],
    },
  },
};

const PEOPLE_REACHED_ID = 10032;
export const getReachIndicators = (
  cause: string | undefined,
  service: string | undefined,
  beneficiaryTerm: string | undefined,
  indicators: IndicatorGroup[],
): Indicator[] => {
  if (!cause || !service || !beneficiaryTerm) return [];

  const indicatorNames = reachIndicatorIds[cause]?.[service];
  if (!indicatorNames) return [];

  const specificIndicators: Indicator[] = [];
  const uniqueIds: { [id: number]: true | undefined } = {};

  for (const x of indicators) {
    for (const y of x.indicators) {
      if (indicatorNames.ids.includes(y.id) && !uniqueIds[y.id]) {
        specificIndicators.push(y);
        uniqueIds[y.id] = true;
      }
    }
  }

  if (specificIndicators.some(i => i.isHuman)) {
    return specificIndicators;
  }

  const result: Indicator[] = [];
  for (const x of indicators) {
    for (const y of x.indicators) {
      if (y.id === PEOPLE_REACHED_ID && !uniqueIds[PEOPLE_REACHED_ID]) {
        result.push(y);
        uniqueIds[PEOPLE_REACHED_ID] = true;
      }
    }
  }

  return [...result, ...specificIndicators];
};

export type GuidanceTextResponse = { [questionId: number]: string };
export const getGuidanceTextBySection = (
  customQuestions: CustomQuestion[],
): GuidanceTextResponse => {
  const result: GuidanceTextResponse = {};
  for (const questions of customQuestions) {
    for (const q of questions.questions) {
      if (q.questionType !== 'guidance') continue;
      const guidance = (q.questionStructure
        .structure as GuidanceTextStructure[])?.[0];
      if (!guidance) continue;
      result[guidance.questionId] = guidance.guidanceText || '';
    }
  }
  return result;
};
